import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './page/App';
import reportWebVitals from './reportWebVitals';
import {positions, Provider} from "react-alert";
import AlertTemplate from "react-alert-template-basic";

var alertStyle = {
    backgroundColor: '#935b5b',
    color: 'white',
    padding: '10px',
    borderRadius: '3px',
    display: 'flex',
    // textTransform: 'uppercase',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0px 2px 2px 2px rgba(0, 0, 0, 0.03)',
    fontFamily: 'Arial',
    width: '300px',
    boxSizing: 'border-box'
};

const options = {
    timeout: 3000,
    position: positions.TOP_CENTER,
}

// const AlertTemplate = ({ style, options, message, close }) => (
//     <div style={alertStyle}>
//         {options.type === 'info' && '!'}
//         {options.type === 'success' && ':)'}
//         {options.type === 'error' && ':('}
//         {message}
//         <button onClick={close}>X</button>
//     </div>
// )

ReactDOM.render(
    <React.StrictMode>
        <Provider template={AlertTemplate} {...options}>
            <App/>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
